import StockSubsectionPlaceholder from "../../../components/StockSubsectionPlaceholder";

export default function TopDesviosPage() {
  return (
    <StockSubsectionPlaceholder
      sectionPath="dashboard"
      subsectionPath="top-desvios"
    />
  );
}
